
const paths = {

    settings(projectId) {
        return `/projects/${projectId}/settings`;
    },

    workflow(projectId) {
        return `/projects/${projectId}/workflow`;
    },

    plugins(projectId) {
        return `/projects/${projectId}/plugins`;
    },

    analytics(projectId) {
        return `/projects/${projectId}/analytics`;
    },

    webhooks(projectId) {
        return `/projects/${projectId}/webhooks`;
    },

    board(projectId, boardId) {
        return `/projects/${projectId}/boards/${boardId}`;
    }
};

export default paths;



// WEBPACK FOOTER //
// ./src/services/paths.js